import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { CAS3_PROVIDERS_ENDPOINT, getAllCas3ProvidersKey } from "./useGetAllCas3Providers";

export const useDeleteCas3Provider = () => {
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: async (id: number) => {
            return loggedInApiCall.delete(`${CAS3_PROVIDERS_ENDPOINT}/${id}`);
        },
        onSuccess: () => queryClient.invalidateQueries([getAllCas3ProvidersKey]),
    });

    return query;
};
